
import style from './title.module.css';
export const Title = ({title}: propsTitle) => {
  return (
    <div className={style.title}>{title}</div>
  )
}
